import React from 'react';
import { useSelector } from 'react-redux';

import { selectMapBannerExperimentEnabled } from '../../selectors/experiments/selectMapBannerExperimentEnabled';
import { DefaultHeaderSectionContainer } from './DefaultHeaderSectionContainer';
import { FlatSaleExpHeaderSectionContainer } from './FlatSaleExpHeaderSectionContainer';

export function HeaderSectionContainer() {
  const mapBannerExperimentEnabled = useSelector(selectMapBannerExperimentEnabled);
  /**
   * Экспериментальная шапка для смешанной выдачи (+вторичка)
   * @todo удалить в рамках CD-163969
   */
  if (mapBannerExperimentEnabled) {
    return <FlatSaleExpHeaderSectionContainer />;
  }

  return <DefaultHeaderSectionContainer />;
}
